<template lang="pug">
  .BaseNotificationInline.notification-inline(
    v-if="value || $slots.default",
    :class="`notification-inline--${type}`",
  )
    p.notification-inline__text
      ExclamationCircleIcon.svg-icon.notification-inline__icon(v-if="type === 'error'")
      TriangleExclamation.svg-icon.notification-inline__icon(v-else)
      span(
        v-if="value",
        v-html="value",
        v-improve-links,
      )
      span(v-else)
        slot
</template>

<script>
import ExclamationCircleIcon from 'images/svg-icons/fa-circle-exclamation.svg';
import TriangleExclamation from 'images/svg-icons/fa-triangle-exclamation.svg';

export default {
  name: 'BaseNotificationInline',
  components: {
    ExclamationCircleIcon,
    TriangleExclamation,
  },
  props: {
    value: String,
    type: {
      default: 'error',
      type: String,
      validator: val => ['error', 'warning'].includes(val),
    },
  },
};
</script>

<style lang="sass" scoped>
@import '~Styles/_variables'
@import  '~Styles/components/_typography.sass'
.notification-inline
  color: $primary
  margin: 3px 0 20px
  border-left: solid 3px transparent
  &__text
    font-size: 14px
    line-height: 19px
    padding: 12px 15px
    margin-bottom: 0
    +font(400)
    display: flex
    align-items: flex-start
    span
      margin-left: 15px
  a
    @extend .link-2
    font-size: 14px
    line-height: 19px
  span
    ::v-deep a
      @extend .link-2
      font-size: 14px
      line-height: 19px
  &__icon
    height: 20px
    width: 20px
    margin-top: -1px
    flex-shrink: 0
  &--error
    background-color: $light_red
    border-color: $support_red
    .notification-inline__icon
      fill: $support_red
    .notification-inline__text
      ::v-deep a
        color: $support_red
        border-color: $support_red
        &:hover
          color: $support_red
          border-color: transparent
  &--warning
    background-color: $orange-20
    border-color: $burnt_sienna
    .notification-inline__icon
      fill: $burnt_sienna
    .notification-inline__text
      ::v-deep a
        color: $burnt_sienna
        border-color: $burnt_sienna
        &:hover
          color: $burnt_sienna
          border-color: transparent
</style>
